/**
 * Calculate the shipping rate for a cart.
 *
 * @param {import("./app/app.models").CartItem[]} items
 * @param {import("./app/components/shopping-cart/shopping-cart.component").ShoppingCartComponent} cart
 */
export function calculateShippingRate(items, cart) {
  // Variable declarations for function
  const subtotal = cart.getSubTotal(); // Pricing structure is now flat rate based on the price of the order.
  const giftCertOnlyRate = 14;
  let paidRate;
  let paidRateAmount;
  let giftCertOnly = false;
  let containsGiftCert = false;

  //-----------------------------------SHIPPING CALCULATIONS---------------------------------------//
  const giftCertUPC = ["GIFTCERT10", "GIFTCERT15", "GIFTCERT20"]; // <----Gift Cert UPCs

  // If the cart only contains gift certificates, special flat shipping rate.
  if (items.length > 0 && items.every((item) => giftCertUPC.includes(item.upc.upc))) {
    giftCertOnly = true;
    paidRateAmount = subtotal >= 100 ? 0 : giftCertOnlyRate;
  }

  if (items.length > 0 && items.some((item) => giftCertUPC.includes(item.upc.upc))) {
    containsGiftCert = true;
  }

  // If the cart contains any other UPC, use flat rate pricing structure.
  if (!giftCertOnly) {
    if (subtotal <= 50) {
      paidRateAmount = 10;
    } else if (subtotal > 50 && subtotal < 100) {
      paidRateAmount = 15;
    } else {
      paidRateAmount = 0;
    }
  }

  if (!giftCertOnly && containsGiftCert && paidRateAmount !== 0) {
    paidRateAmount += 4.95;
  }

  // Convert the rate to a string to match ShippingRateInfo-like usage
  paidRate = paidRateAmount.toString();

  return {
    paidRate,
    paidRateAmount,
    containsGiftCert,
    giftCertOnly,
  };
}

